<template>
    <li class="scheduling-date-and-time-item">
        <button v-if="form.integrationFormType=='event'" :class="schedulingDateAndTimeClass"
            :value="item.id"
            v-on:click="$emit('filled-out', item.id)">
            {{startDate | range(endDate)}}
        </button>
        <button v-else :class="schedulingDateAndTimeClass"
            :value="item.id"
            v-on:click="$emit('filled-out', item.id)">
            {{startDate | justTime}}
        </button>
    </li>
</template>

<script>
  import moment from 'moment';
  import { mapState } from 'vuex';

  export default {
    data() {
        return {
            startDate: '',
            endDate: ''
        }
    },
    props: {
      item: {},
      value: '',
    },
    methods: {
        dateToMoment(stringDate) {
            const date = new Date(stringDate.replace(' ', 'T'));
            return moment(date).subtract(date.getTimezoneOffset()*60, 'seconds');
        }
    },
    computed: {
        ...mapState('form', { form: 'form'}),
        getValueId() {
            return this.value ? this.value.id : '';
        },
        schedulingDateAndTimeClass() {
            return {
                "event-date-and-time-select": this.form.integrationFormType=='event',
                'service-date-and-time-select': this.form.integrationFormType=='service',
                "btn-step-select": true,
                "selected": this.getValueId==this.item.id
            };
        }
    },
    filters: {
        justTime(momentDate) {
            return momentDate.format('h:mm a');
        },
        range(startDate, endDate) {
            if (startDate.format('YYYYMMDD') != endDate.format('YYYYMMDD')) {
                return startDate.format('ddd - M/D/YYYY @ h:mma') +
                ', to ' +
                endDate.format('ddd - M/D/YYYY @ h:mma');
            } else {
                return startDate.format('ddd - MMM D, YYYY') +
                ' from ' +
                startDate.format('h:mma') +
                ' - '+
                endDate.format('h:mma');
            }
        }
    },
    created() {
        this.startDate = this.dateToMoment(this.item.startDateTime);
        this.endDate = this.dateToMoment(this.item.endDateTime);
    }
  };
</script>
<style>
ul li.scheduling-date-and-time-item {
    margin-bottom: 10px;
}
.scheduling-date-and-time-item > .btn-step-select {
    display:block;
    width:100%;
}
</style>
